<template>
  <v-stepper v-model="stepper"
             light
             vertical
             non-linear
             class="registration-stepper elevation-0">
    <v-stepper-step :complete="stepperStatus.start.complete"
                    step="1">
      <router-link to="/" class="router-link">
        <span>{{ $t('stepper.start') }}</span>
      </router-link>
    </v-stepper-step>
    <v-stepper-content step="1" />

    <template v-if="skipOrder !== null && !skipOrder">
      <v-stepper-step :complete="stepperStatus.order.complete"
                      step="2"
                      :rules="[() => !stepperStatus.order.errors]">
        <router-link to="/order"  class="router-link">
          <span>{{ $t('stepper.orderInfo') }}</span>
        </router-link>
      </v-stepper-step>
      <div class="custom-stepper-content" v-if="skipOrder !== null && !skipOrder">
        <v-expand-transition>
          <div>
            <ul class="tree">
              <li>
                <router-link to="/order"
                             class="clickable router-link"
                             exact
                             :class="{ 'error--text': orderInformationError, 'success--text': dirtyOrderInformation && !orderInformationError }">
                  <span>{{ $t('stepper.order.basic') }}</span>
                </router-link>
              </li>
            </ul>

            <ul class="tree">
              <li>
                <router-link to="/order/debtor"
                             class="clickable router-link"
                             :class="{ 'error--text': dirtyDebtors && debtorError, 'success--text': dirtyDebtors && !debtorError }">
                  <span>{{ $t('stepper.order.debtors') }}</span>
                </router-link>
                <ul v-if="debtors.length > 1">
                  <li v-for="(debtor, i) in debtors"
                      :key="i">
                    <router-link class="text-caption clickable router-link"
                                 :to="{ 'path': '/order/debtor#debtor-' + (i * 1 + 1) }"
                                 :class="{ 'error--text': !debtor.isValid && debtor.isDirty, 'success--text': debtor.isValid }">
                      <span>{{ $t('stepper.order.debtor') }} {{ debtor.isCompany ? debtor.companyName : debtor.lastName }}</span>
                    </router-link>
                  </li>
                </ul>
              </li>
            </ul>

            <ul class="tree">
              <li>
                <router-link class="clickable router-link"
                             :class="{ 'error--text': dirtyBills && billError, 'success--text': dirtyBills && !billError }"
                             to="/order/bill">
                  <span>{{ $t('stepper.order.bills') }}</span>
                </router-link>
                <ul v-if="bills.length > 1">
                  <li v-for="(bill, i) in bills"
                      :key="i">
                    <router-link class="text-caption clickable router-link"
                                 :to="{ 'path': '/order/bill#bill-' + (i * 1 + 1) }"
                                 :class="{ 'error--text': !bill.isValid && bill.isDirty, 'success--text': bill.isValid }">
                      <span>{{ $t('common.bill') }} {{ bill.billNr }}</span>
                    </router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </v-expand-transition>
      </div>
    </template>

    <v-stepper-step :complete="stepperStatus.client.complete"
                    :step="skipOrder !== null && !skipOrder ? 3 : 2"
                    :rules="[() => !stepperStatus.client.errors]">
      <router-link to="/basic-information" class="router-link">
        <span>{{ $t('stepper.client') }}</span>
      </router-link>
    </v-stepper-step>
    <v-stepper-content :step="skipOrder !== null && !skipOrder ? 3 : 2" />

    <v-stepper-step :complete="stepperStatus.moneyLaundering.complete"
                    :step="skipOrder !== null && !skipOrder ? 4 : 3"
                    :rules="[() => !stepperStatus.moneyLaundering.errors]">
      <router-link to="/money-laundering" class="router-link">
        <span>{{ $t('stepper.moneyLaundering') }}</span>
      </router-link>
    </v-stepper-step>
    <v-stepper-content :step="skipOrder !== null && !skipOrder ? 4 : 3" />
    <v-stepper-step :complete="stepperStatus.signing.complete"
                    :step="skipOrder !== null && !skipOrder ? 5 : 4"
                    :rules="[() => !stepperStatus.signing.errors]">
      <router-link class="router-link" to="/digital-signing">
        <span>{{ $t('stepper.signing') }}</span>
      </router-link>
    </v-stepper-step>
  </v-stepper>
</template>

<script>
  export default {
    computed: {
      stepper: {
        get: function () {
          return this.$store.getters.stepper
        },
        set: function () { }
      },
      stepperStatus() {
        return this.$store.getters.stepperStatus
      },
      bills() {
        return this.$store.getters.bills
      },
      dirtyOrderInformation() {
        return this.$store.getters.dirtyOrderInformation
      },
      orderInformationError() {
        return this.$store.getters.orderInformationError
      },
      dirtyBills() {
        return this.$store.getters.dirtyBills
      },
      billError() {
        return this.$store.getters.billError
      },
      debtors() {
        return this.$store.getters.debtors
      },
      dirtyDebtors() {
        return this.$store.getters.dirtyDebtors
      },
      debtorError() {
        return this.$store.getters.debtorError
      },
      skipOrder() {
        return this.$store.getters.skipOrder
      }
    }
  }
</script>
